import { inject, Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { UserInformationService } from '../user/user-information.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly oauthService = inject(OAuthService);
  private readonly userInformationService = inject(UserInformationService);

  public hasValidAccessToken(): boolean {
    return this.oauthService.hasValidAccessToken();
  }

  public logout(): void {
    this.userInformationService.removeSavedAccount();
    this.oauthService.logOut();
  }
}
